import CustomerInfo from './CustomerInfo'

export default CustomerInfo


// WEBPACK FOOTER //
// ./src/features/OrderDetails/components/CustomerInfo/index.js